import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  importersGroup: {
    display: 'flex',

    '& form': {
      '&:not(last-child)': {
        marginRight: theme.spacing(2),
      },
    },
  },

}));

export default useStyles;
